import React, { useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Container, Box, Typography } from '@mui/material';
// import GoogleIcon from '@mui/icons-material/Google'; // 구글 아이콘
import logo from './image/img.jpeg'; // 로고 이미지 경로
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import InstagramIcon from '@mui/icons-material/Instagram';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import QuestionAnswerIcon from '@mui/icons-material/ContactSupport';

import IconButton from '@mui/material/IconButton';

// const CLIENT_ID = '710539770853-c8sdv6bmhh122lrs71mecdu72e6b6n0a.apps.googleusercontent.com'; // Google Cloud Console에서 발급받은 클라이언트 ID

const App = () => {

  useEffect(() => {
    document.title = '선gpt';
  }, []);


  const navigate = useNavigate();

  const handleSuccess = (response) => {

    console.log(response);

    const { credential } = response;
    // console.log('Login Success. Credential:', credential);
    // 서버로 토큰을 보내는 로직
    fetch('http://13.124.203.56/sungpt/get_user.php', { // PHP 서버의 경로
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token: credential }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('Server Response:', data);
        if (data.success) {
          console.log('Signed user', data.message);

        } else {
          navigate('/sungptSignup'); // '/newpage' 경로로 이동
        }
      })
      .catch((error) => {
        console.error('Error during token verification:', error);
      });
  };

  const handleCardClick = () => {
    navigate('/sungptSignup'); // '/newpage' 경로로 이동
  };

  const checkapply = () => {
    navigate('/checkapply'); // '/newpage' 경로로 이동
  };



  const handleError = (error) => {
    console.error('Login Error:', error);
    // 여기에 구글 로그인 실패 후 처리 로직 추가
  };

  return (
      <Container
        component="main"
        maxWidth="md"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh', // Viewport height를 사용하여 중앙에 위치
        }}
      >
        <Box
          sx={{
            textAlign: 'center', // 중앙 정렬을 위해 추가
          }}
        >

        <Box
          sx={{
              display: 'flex',
              justifyContent: 'center', // 가로 방향으로 중앙 정렬
              alignItems: 'center', // 세로 방향으로 중앙 정렬
              gap: 3, // 아이콘 사이의 간격
            }}
            >
            <IconButton onClick={() => navigate('/')} color="primary">
              <HomeOutlinedIcon sx={{ color: 'black', fontSize: '2.5rem' }} />
            </IconButton>

            <IconButton
              color="black"
              aria-label="instagram"
              href="https://www.instagram.com/meethumb_"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'black'}}
            >
              <InstagramIcon sx={{ fontSize: '2.3rem' }} />
            </IconButton>

            <IconButton onClick={() => navigate('/qna')} color="primary">
              <QuestionAnswerIcon sx={{ color: 'black', fontSize: '2.5rem' }} />
            </IconButton>
            </Box>



          <Box sx={{ mt:4, mb: 2 }}>
            <img src={logo} alt="Logo" style={{ width: '260px', height: 'auto' }} />
          </Box>


          <Typography variant="h5" gutterBottom
          sx={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: 'bold'
          }}>
            AI가 찾아주는 닮은 꼴 이성
          </Typography>

          <Typography variant="h7" gutterBottom style={{ lineHeight: '2em' }}>
            - 미국 연구팀 89% 남녀 닮은 꼴 이성에게 끌리는 연구결과 보도<br />
            - 첫 1회 무료, 후불형 소개팅
          </Typography>

          <Box sx={{ mt: 2 }}>

          <Container component="main" maxWidth="xs" >
          <Button variant="contained" sx={{ height:'45px', width:'260px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
            onClick={handleCardClick}
          >
            바로 시작하기
          </Button>

          <Button variant="contained" sx={{mt:3, height:'45px', width:'260px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
            onClick={checkapply}
          >
            신청 확인
          </Button>




          </Container>


          </Box>
        </Box>
      </Container>

  );
};

export default App;
